<template>
    <div v-if="appReady" class="container-fluid">
        <div v-if="isLayout('blank')" class="row">
            <router-view></router-view>
        </div>
        <p v-if="1==2" class="text-center" style="position: absolute;z-index: 100000;font-size: 11px;background: #fff;padding: 1px 5px;border-radius: 0px 0px 4px 4px;left: 50%;margin-left: -45px;"><small>Device Size {{wWidth}} x {{wHeight}}</small></p>
        <div v-if="isLayout('default')" class="row page-content" :class="{'hasFooter': hasFooter, 'hasHeader': !isAndroid}">
            <main class="default">
                <div class="main-content" :key="componentKey">
                    <transition name="page-transition-1" mode="out-in">
                         <keep-alive>
                             <router-view :key="$route.fullPath"></router-view> 
                         </keep-alive>
                    </transition>
                </div>
            </main>

            <music-player></music-player>
            <playlist-popup v-if="showPlaylistPopup" :song="playlistPopupSong"></playlist-popup>

            <div id="footer" class="container text-center" :class="{'disabled': !hasFooter}">
                <div class="row links">
                    <div class="col-xs-3">
                        <div class="button button-center button-white" @click="changePage('/home')" :class="{'router-link-active' : isPage('/home')}">
                            <span class="iconify" data-icon="mdi:library-music-outline" data-inline="false"></span>
                            <span class="unread-badge" v-show="newSuggestions">{{ newSuggestions }}</span>
                        </div>
                    </div>

                    <div class="col-xs-3">
                        <div class="button button-center button-white" @click="changePage('/search')" :class="{'router-link-active' : isPage('/search')}">
                            <span class="iconify" data-icon="ic:sharp-search" data-inline="false"></span>
                        </div>
                    </div>

                    <div class="col-xs-3">
                        <div class="button button-center button-white" @click="changePage('/profile')" :class="{'router-link-active' : isPage('/profile')}">
                            <span class="iconify" data-icon="mdi:account-outline" data-inline="false"></span>
                        </div>
                    </div>

                    <div class="col-xs-3">
                        <div class="button button-center button-white" @click="changePage('/messages')" :class="{'router-link-active' : isPage('/messages')}">
                            <span class="iconify" data-icon="mdi:message-text-outline"></span>
                            <span class="unread-badge" v-show="newMessages.total">{{ newMessages.total }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="!isAndroid" id="notification-bar"></div>
    </div>

    <div v-else class="container">
        <div class="row">
            <div id="page-loading" class="col-xs-12 text-center fade-in-top-delay">
                <loader color="ripple" size="250px"></loader>
                <h2 class="fontRaleway font-w-900">SoundFeed</h2>
            </div>
        </div>
    </div>
</template>

<script>
import Echo from "laravel-echo";

export default {
    components: {
        'music-player': require('@/components/MusicPlayer.vue').default,
        'playlist-popup': require('@/components/Song/Widget/PlaylistPopup.vue').default,
        'loader': require('@/components/Loader.vue').default,
    },

    beforeCreate() {
        // check if page doesn't require login.
        var noLoginPage = false; //window.location.pathname.indexOf('song') > -1 || window.location.pathname.indexOf('profile') > -1 || window.location.pathname.indexOf('playlist') > -1;

        if (!App.user && !noLoginPage ){
            this.$router.push('/login');
            return;
        }else{
          
        }
    },

    data() {
        return {
            componentKey: 0,
            showPlaylistPopup: false,
            playlistPopupSong: 0,
            playlistPopupTarget: false,
            appReady: false,

            newSuggestions: 0,
            newMessages: {
                total: 0
            },
            newConversation: null, 
            wHeight: 0,
            wWidth:0           
        }
    },

    mounted() {
        this.wHeight = $(window).height();
        this.wWidth = $(window).width();
        App.status = 'active';

        if ( App.user === false || App.OSID === false ){
            console.log('NO USER .. wait for OneSignal');
            // try to fetch OSID from OneSignal 50 attemtps, over 5s
            var attempts = 0;
            var attempt = setInterval(() => {
                if (localStorage.getItem("osid") || attempts++ > 100) {
                    App.OSID = localStorage.getItem("osid");
                    clearInterval(attempt);
                    this.fetchData(() => { 
                        this.appReady = true; 
                    });
                }
            }, 100);
        }else{
            App.allowGtag = [21,23,25,27,28,91,238,272].indexOf(App.user.id) == -1;
            this.fetchData(() => { 
                this.appReady = true; 
            });
        }

        document.addEventListener("visibilitychange", () => {
            if (App.user == false) return;

            if (document.hidden == false){
                this.getMessagesBadges({action: 'get'});
                App.status = 'active';
            }else{
                App.status = 'inactive';
            }

            $('#message-box').blur();
        }, false);
        
        $('body').addClass(App.platform);

        $(document).on('focusin', () => {
            $('body').addClass('keyboard-open');
        }).on('focusout', () => {
            $('body').removeClass('keyboard-open');
        })

        //activity monitoring
        setInterval(() => {
            if (App.status == 'active' && App.user){
                this.$http.put(App.restApi + '/api/user/' + App.user.id + '/activity/mobile');
            }
        }, 5000);

        // 1min idle time
        var secondsSinceLastActivity = 0;
        setInterval(() => {
            secondsSinceLastActivity++;
            if (secondsSinceLastActivity > 15){
                App.status = 'inactive';
            }
        }, 1000);

        ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart'].forEach((eventName) => {
            document.addEventListener(eventName, () => {
                secondsSinceLastActivity = 0;
                App.status = 'active';
            }, true);
        });


        this.listenForEvents();
    },

    methods: {
        fetchData(callback){
            this.$http.get(App.restApi + '/api/server-time').then((success) => {
                App.server = {
                    time: success.data.timestamp,
                    local: moment().format('x')/1000,
                    offset: Math.floor(moment().format('x')/1000 - success.data.timestamp) + 60*60*2
                }
            });

            this.$http.get(App.restApi + '/api/user/' + App.user.id + '/filters?format=web').then((success) => {
                console.log('USER DATA FETCHED', success.data.data);
                var rawFilters = success.data.data;
                var available_in = [];
                var licensed_in = [];
                var genres = [];

                if (rawFilters.countries && rawFilters.countries.length){
                    $.each(rawFilters.countries, function(i, elem){
                        if (elem.status > 0) available_in.push(elem.id);
                    });
                }

                if (rawFilters.genres && rawFilters.genres.length){
                    $.each(rawFilters.genres, function(i, elem){
                        if (elem.status > 0) genres.push(elem.id);
                    });
                }

                App.filters = {
                    available_in: available_in,
                    licensed_in: licensed_in,
                    genres: genres,
                    raw: rawFilters
                }

                App.search = {
                    term: "",
                    genres: genres,
                    available: available_in,
                    licensed: licensed_in,
                    formatted: {
                        countries: [],
                        genres: []
                    }
                }

                //Fetch playlist
                this.$http.get(App.restApi + '/api/v2/playlists').then((success) => {
                    App.playlists = success.data.data;
                    callback();
                });

            }, (error) => {
                App.user = false;
                this.appReady = true;
                this.$router.push('/login');
            });

            //establish pusher connection
            window.Echo = new Echo({
                broadcaster: 'pusher',
                key: 'c4427c3c707768cfe7a2',
                cluster: 'eu',
                authEndpoint: App.restApi + '/api/broadcasting/auth',
                auth: {
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('token') // user token after auth
                    }
                }
            });

            this.connectToChannel();
        },

        listenForEvents() {
            this.$root.$on('forcePageReload', () => {
                this.componentKey += 1
            });

            this.$root.$on('appNotReady', () => {
                this.appReady = false;
                this.fetchData(() => { this.appReady = true; });
            });

            this.$root.$on('showPlaylistManager', (song) => {
                console.log(song);
                this.showPlaylistPopup = true;
                this.playlistPopupSong = song;
            });

            this.$root.$on('hidePlaylistManager', () => {
                this.showPlaylistPopup = false;
            });

            this.$root.$on('pickUpdated', (pick, uid) => {
                this.$http.get(this.userEndpoint).then((success) => {
                    App.user.songs_of_blocked_users = success.data.data.songs_of_blocked_users;
                    localStorage.setItem('appuser', JSON.stringify(App.user));
                    this.$root.$emit('reloadSongsList');
                });
            });

            this.$root.$on('getUserPublicInfo', () => {
                this.getUserPublicInfo();
            });

            this.$root.$on('suggestions-loaded', () => {
                this.newSuggestions = 0;
            });

            this.$root.$on('messages-badges', this.getMessagesBadges);
            this.$root.$on('suggestions-badges', this.getSuggestionsBadges);
        },

        getMessagesBadges(params){
            if (params.action == 'get'){
                this.$http.get(App.restApi + '/api/v2/conversations/unread').then((success) => {
                    this.$root.$emit('messages-badges', {action: 'set', value: success.data});
                });
            }

            if (params.action == 'set'){
                this.newMessages = params.value;
            }

            if (params.action == 'ask'){
                this.$root.$emit('messages-badges', {action: 'set', value: this.newMessages});
            }            
        },

        getSuggestionsBadges(params){
            if (params.action == 'get'){
                this.$http.get(App.restApi + '/api/v2/suggestions/not-viewed').then((success) => {
                    this.$root.$emit('suggestions-badges', {action: 'set', value: success.data.not_viewed_suggestions_count});
                });
            }

            if (params.action == 'set'){
                this.newSuggestions = params.value;
            }

            if (params.action == 'ask'){
                this.$root.$emit('suggestions-badges', {action: 'set', value: this.newSuggestions});
            }
        },

        updateSuggestionsTo(value){
            this.newSuggestions = value;
        },

        changePage(route) {
            if ($('#musicplayer').is('.maximized')){
                $('#musicplayer').animate({ scrollTop: 0 }, 500);
                $('#musicplayer').removeAttr('class').addClass('opened minimized');
                $('.page-content').removeClass('hasPlayerMaxed');
            }

            this.showPlaylistPopup = false;
            this.$router.push(route);
        },

        isPage(route){
            return route == this.$route.path;
        },

        getUserPublicInfo() {
            this.$http.get(this.getUserPublicInfoEndpoint).then((success) => {
                App.user = success.data.data;
            });
        },

        connectToChannel() {
            // Connect to channels
            // Increment badge when a suggestion is received
            window.Echo.private('suggestions.' + App.user.id)
                .listen('User\\SongSuggested', (e) => {
                    this.newSuggestions += 1;
                    this.$root.$emit('suggestions-badges', {action: 'set', value: this.newSuggestions});
                });

            window.Echo.private('suggestions.' + App.user.id)
                .listen('User\\PlaylistSuggested', (e) => {
                    this.newSuggestions += 1;
                    this.$root.$emit('suggestions-badges', {action: 'set', value: this.newSuggestions});
                });                
            
            window.Echo.private('conversation.activity')
                .listen('Conversation\\ActivityDetected', (e) => {
                    if (e.conversation_id != App.conversation_id) {
                        this.getMessagesBadges({action: 'get'});
                    }
                });

            this.getMessagesBadges({action: 'get'});
            this.getSuggestionsBadges({action: 'get'});
        },

        isLayout(layout){
            return this.$route.meta.layout == layout;
        },
    },

    computed: {
        isAndroid(){
            return true;//App.platform == 'android';
        },

        layout(){
            return this.$route.meta.layout;
        },

        noCredentialsPage() {
            return window.location.pathname.indexOf('/login') > -1 || 
                   window.location.pathname.indexOf('/register') > -1 || 
                   window.location.pathname.indexOf('/logout') > -1;                    
                   // window.location.pathname.indexOf('/song') > -1 || 
                   // window.location.pathname.indexOf('/profile') > -1 || 
                   // window.location.pathname.indexOf('/playlist') > -1;
        },

        getUserPublicInfoEndpoint() {
            return App.restApi + '/api/user/' + App.user.id + '/public-info';
        },

        hasFooter(){
            return this.$route.meta.footer;
        },

        userEndpoint() {
            return App.restApi + '/api/user/' + App.jwt.user_id + '/public-info';  
        },
    },

    beforeDestroy() {
        // this.$root.$off(['forcePageReload', 'appNotReady', 'showPlaylistManager', 'pickUpdated']);
    }    
}
</script>
